import { useCallback, useEffect } from 'react';
import type { Channel, Event } from 'stream-chat';
import { StreamEventType } from '@features/components/Chat/constants';

export const useChannelEvents = (
  channel: Channel | undefined,
  {
    onRemoved,
    onMessageUpdated,
  }: {
    onRemoved: () => void;
    onMessageUpdated: () => void;
  },
) => {
  const channelId = channel?.id;

  const handleRemoved = useCallback(
    (event: Event) => {
      if (channelId && event.channel_id === channelId) {
        onRemoved();
      }
    },
    [channelId, onRemoved],
  );

  useEffect(() => {
    if (!channel) return () => {};

    onMessageUpdated();
    channel.on(StreamEventType.REMOVED_FROM_CHANNEL, handleRemoved);
    channel.on(StreamEventType.MESSAGE_UPDATED, onMessageUpdated);

    return () => {
      channel.off(StreamEventType.REMOVED_FROM_CHANNEL, handleRemoved);
      channel.off(StreamEventType.MESSAGE_UPDATED, onMessageUpdated);
    };
  }, [channel, handleRemoved, onMessageUpdated]);
};
